import { FormControl, Input, ListItemText, MenuItem } from '@mui/material';
import React from 'react';
import Select from '@mui/material/Select';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  textfield: {
    width: (props) => props.width || '321px',
    height: (props) => props.height || '44px',
    padding: '12px 12px 12px 12px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
  },
}));

const CustomDropDown = ({
  handleChange,
  value,
  width,
  height,
  marginBottom,
  list,
  name,
  disabled = false,
  showLabel = false,
  label = '',
}) => {
  const styleProps = {
    width,
    height,
    marginBottom,
  };
  const classes = useStyles(styleProps);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const dropdownListItems = () => {
    const items = [];
    list?.forEach((option) => {
      items.push(
        <MenuItem
          key={`${option.id}-${option.title || option.name || option.displayName}`}
          name={option.id}
          value={option.id}
        >
          <ListItemText
            primary={option.title ?? option.name ?? option.displayName}
            primaryTypographyProps={{
              fontFamily: 'Lato',
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: '19.6px',
              color: '#667085',
            }}
          />
        </MenuItem>,
      );
    });
    return items;
  };
  const controlWidth = width || '321px';

  return (
    <FormControl fullWidth sx={{ width: controlWidth, maxWidth: '100%', boxSizing: 'border-box' }}>
      <Select
        fullWidth
        name={name}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={value || 'Select'}
        onChange={handleChange}
        input={
          <Input
            sx={{ fontFamily: 'Lato', fontWeight: '500', fontSize: '12px', width: '100%' }}
            disableUnderline
            className={classes.textfield}
          />
        }
        renderValue={(selected) => (showLabel ? label : selected)}
        MenuProps={MenuProps}
        disabled={disabled}
      >
        {dropdownListItems()}
      </Select>
    </FormControl>
  );
};

export default React.memo(CustomDropDown);
